//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */
import brandTaggerTemplate from '@partials/brand-tagger.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('brandTagger', ['TrackingService',
    function(TrackingService) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          disabled: '@',
          placeholder: '@',
          tags: '=',
        },
        template: brandTaggerTemplate,
        controller: ['$http', '$scope',
          function($http, $scope) {
            $scope.model = {};

            $scope.model.getBrandTagsAsync = function(tagSearch) {
              const params = {
                'search': tagSearch,
                'limit': 8,
              };
              return $http.get('/api/labels/search', {
                params,
              }).then(
                                response => _(response.data).map(tag => ({ tag: tag.label })),
                                () => [], // If there is an error, just return empty as this is for autocomplete
                            );
            };
          },
        ],
        link($scope, $element, $attrs) {
                    // Initialize to default actions if none are set.
          $scope.trackingActionAddTag = $attrs.trackingActionAddTag || TrackingService.ACTION_ADD_TAG;
          $scope.trackingActionRemoveTag = $attrs.trackingActionRemoveTag || TrackingService.ACTION_REMOVE_TAG;

          $scope.trackingCategory = $attrs.trackingCategory || TrackingService.CATEGORY_BRAND_TAGGER;
        },
      };
    },
  ]);
})();
